import { BreakpointObserver } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { MaterialPage } from 'src/app/components/page/material-page.component';
import { SidenavService } from 'src/app/_services/sidenav.service';

@Component({
  templateUrl: './listing-created-page.component.html',
  styleUrls: ['./listing-created-page.component.scss']
})
export class ListingCreatedPageComponent extends MaterialPage {

  constructor(
    breakpointObserver: BreakpointObserver,
    titleService: Title,
    meta: Meta,
    private router: Router,
    sidenavService: SidenavService
  ) {
    super(breakpointObserver, titleService, meta, sidenavService, router, $localize `:page title:Success!`, '', true);
  }
  
  toItemList() {
    this.router.navigate(['items-to-sell']);
  }
  
  toSelectListingFlow() {
    this.router.navigate(['select-listing-flow']);
  }
}
